import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Switch } from '../ui/switch';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

export const ProfileForm = ({ 
  formData, 
  isEditing, 
  isLoading,
  onSubmit, 
  onChange, 
  onSessoChange,
  onCancel 
}) => {
  return (
    <Card className="mb-8">
      <CardHeader>
        <CardTitle className="text-2xl text-burgundy">
          {isEditing ? 'Modifica Profilo' : 'Nuovo Profilo'}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={onSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <Label htmlFor="nome">Nome *</Label>
              <Input
                id="nome"
                name="nome"
                value={formData.nome}
                onChange={onChange}
                placeholder="Nome del profilo"
                required
              />
            </div>

            <div>
              <Label htmlFor="sesso">Sesso *</Label>
              <Select value={formData.sesso} onValueChange={onSessoChange}>
                <SelectTrigger>
                  <SelectValue placeholder="Seleziona sesso" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="Uomo">Uomo</SelectItem>
                  <SelectItem value="Donna">Donna</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label htmlFor="eta">Età *</Label>
              <Input
                id="eta"
                name="eta"
                type="number"
                value={formData.eta}
                onChange={onChange}
                placeholder="Età"
                min="25"
                max="80"
                required
              />
            </div>

            <div>
              <Label htmlFor="fasciaEta">Fascia Età</Label>
              <Input
                id="fasciaEta"
                name="fasciaEta"
                value={formData.fasciaEta}
                readOnly
                placeholder="Auto-calcolata"
                className="bg-gray-50"
              />
            </div>
          </div>

          <div>
            <Label htmlFor="bio">Biografia *</Label>
            <Textarea
              id="bio"
              name="bio"
              value={formData.bio}
              onChange={onChange}
              placeholder="Descrizione del profilo..."
              rows={5}
              required
            />
          </div>

          <div className="flex items-center space-x-3">
            <Switch
              id="attivo"
              checked={formData.attivo}
              onCheckedChange={(checked) => 
                onChange({ target: { name: 'attivo', value: checked } })
              }
            />
            <Label htmlFor="attivo" className="cursor-pointer">
              Profilo Attivo
            </Label>
          </div>

          <div className="flex gap-3">
            <Button
              type="submit"
              className="btn-primary"
              disabled={isLoading}
            >
              {(() => {
                if (isLoading) return 'Salvataggio...';
                if (isEditing) return 'Aggiorna';
                return 'Crea Profilo';
              })()}
            </Button>
            <Button
              type="button"
              variant="outline"
              onClick={onCancel}
              disabled={isLoading}
            >
              Annulla
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
};
